import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { IUnauthenticatedInvoiceDataDto } from '../../interfaces/dtos/client/IUnauthenticatedInvoiceDataDto';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IJsonApiResponse } from '../../interfaces/api/IJsonApiResponse';

@Injectable({
  providedIn: 'root'
})
export class UnauthenticatedInvoicesService {
  private readonly HttpClient = inject(HttpClient);

  private GetApiBasePath(): string{
    return `/api/v1/no-auth/invoices`;
  }

  public GetUnauthenticatedInvoiceData(id: number, uuid: string): Observable<IJsonApiResponse<IUnauthenticatedInvoiceDataDto>>{
    return this.HttpClient.get<IJsonApiResponse<IUnauthenticatedInvoiceDataDto>>(environment.API_HOST +  this.GetApiBasePath() + `/${id}/${uuid}`, {
      headers: {
        "Content-Type": "application/json",
      }
    });
  }

  public GetHostedUrlForInvoice(invoiceId: number, invoiceUuid: string): Observable<IJsonApiResponse<string>>{
    return this.HttpClient.get<IJsonApiResponse<string>>(environment.API_HOST +  this.GetApiBasePath() + `/${invoiceId}/${invoiceUuid}/hosted-url`, {
      headers: {
        "Content-Type": "application/json",
      }
    });
  }
}
